import * as React from 'react';
import Geosuggest, { Suggest } from 'react-geosuggest';

interface ILocationInputProps {
  edit: boolean;
  localisation: {
    label: string;
    location: { lat: number; lng: number };
  };
  handleLocationUpdate: (localisation: {
    label: string;
    location: { lat: number; lng: number };
  }) => void;
}

interface ILocationInputState {
  isOpen: boolean;
}

export class LocationInput extends React.Component<
  ILocationInputProps,
  ILocationInputState
> {
  public state = {
    isOpen: false,
  };

  public handleChange = () => {
    this.setState({ isOpen: true });
  };


/*
  public onSuggestSelect = (suggest :Suggest) => {
    if (!suggest.gmaps) {
      return;
    }
  
    const components = suggest.gmaps.address_components;
      const address = {
       city : this.findAddressComponent(components, 'locality', 'short_name'),
       state: this.findAddressComponent(components, 'administrative_area_level_1', 'short_name'),
       street: this.findAddressComponent(components, 'street_number', 'short_name') + ' ' + this.findAddressComponent(components, 'route', 'short_name'), 
       zip: this.findAddressComponent(components, 'postal_code', 'short_name'),
     };
    alert(address.street);
    alert(address.city);
    alert(address.state);
    alert(address.zip);
  }
  
  public findAddressComponent = (components : google.maps.GeocoderAddressComponent[], type : string , version : string )  => {
    const address = components.find((component : any) => {
      return (component.types.indexOf(type) !== -1);
    });
   if(address){
    return address[version];
    }
  }
*/

 public onSuggestSelect = (suggest: Suggest) => {
   if (suggest) {
       const { handleLocationUpdate } = this.props;
       handleLocationUpdate({
         label: suggest.label,
         location: {
           lat: parseFloat(suggest.location.lat),
           lng: parseFloat(suggest.location.lng),
         },
      });
       this.setState({ isOpen: false });
    }
   };

  public componentWillReceiveProps = (nextProps: ILocationInputProps) => {
    if (!nextProps.edit) {
      this.setState({ isOpen: false });
    }
  };

  public render() {
    const { edit, localisation } = this.props;
    const { isOpen } = this.state;

    return (
      <Geosuggest
        inputClassName='form-control'
        suggestsClassName={isOpen ? '' : 'd-none'}
        initialValue={
          localisation && localisation.label ? localisation.label : ''
        }
        placeholder='Localisation'
        disabled={!edit}
        location={new google.maps.LatLng(48.864716, 2.349014)}
        radius={20}
        onSuggestSelect={this.onSuggestSelect}
        onChange={this.handleChange}
        country={"Fr"}
       // types={["geocode", "(cities)"]}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Input/LocationInput.tsx